import React, { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModel from "../../Components/DeleteModel";
import { deleteItem, fetchData } from "../../utils/apiUtils";
import { ActionButton, PlusButton } from "../../helper/ImageFormat";
import CustomPagination from "../../helper/Pagination";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import PerPageSelect from "../../Components/PerPageSelect";
import TableSearch from "../../Components/TableSearch";
import dateformate from "../../helper/DateFormate";

const StitchingPage = () => {
 const [loading, setLoading] = useState(false);
 const [stitchingdata, setstitchingdata] = useState([]);
 const navigator = useNavigate();
 const [deleteItemId, setDeleteItemId] = useState({});
 const [totalCount, setTotalCount] = useState(0);
 const [currentPage, setCurrentPage] = useState(1);
 const [perPage, setPerPage] = useState(10);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);
 const [search, setSearch] = useState("");
 const handleEditClick = (item) => {
  navigator("/stitching-group", { state: item });
 };

 const totalPages = Math.ceil(totalCount / perPage);
 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchStitching(page);
  }
 };

 const fetchStitching = async (page = 1,searchQuery = "") => {
  const requestData = {
   perPage: perPage,
   pageNo: page,
   search: searchQuery,
  };
  await fetchData(
   "stitching-option-pagination",
   requestData,
   setstitchingdata,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
 };


 useEffect(() => {
         const delay = search ? 500 : 0;
         const handler = setTimeout(() => {
         fetchStitching(currentPage, search);
         }, delay);
         return () => clearTimeout(handler);
     }, [search, perPage]);



 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };



  const confirmDelete = async () => {
     setIsDeleting(true);
     try {
       const res = await deleteItem("stitching-group", deleteItemId?.id, fetchStitching);
       setDeleteItemId({});
       setDeleteModalOpen(false);
       return res;
     } catch (err) {
       throw err;
     } finally {
       setIsDeleting(false);
     }
   };



 const HandleAdd = () => {
  navigator("/stitching-group", { state: {} });
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Stitchings", path: "*" },
 ];

 return (
  <>
   <div className="content-wrapper">
    <div
     className="page-header mt-5"
     style={{ display: "flex", justifyContent: "space-between" }}
    >
     <h3 className="custom-page-title">Stitchings</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-2"
     style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
    >
    <PerPageSelect value={perPage} onChange={setPerPage}/>

     <div style={{ display: "flex", gap: "20px" }}>
      <TableSearch value={search} onChange={setSearch} />
      <PlusButton handleAdd={HandleAdd} module={"stitching"}/>
     </div>
    </div>

    <div className="row">
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <div className="pb-20 table-responsive">
         <table
          className=" custom-table table table-striped"
          id="stitchingTable"
         >
          <thead>
           <tr>
            <th > Name</th>
            <th > Category</th>
            <th > Options</th>
            <th > Updated At</th>
            <th > Actions</th>
           </tr>
          </thead>
          <tbody>
           {loading ? (
            <tr>
             <td colSpan="7" className="text-center">
              <Spinner />
             </td>
            </tr>
           ) : stitchingdata.length > 0 ? (
            stitchingdata.map((item, id) => {
             return (
              <tr key={id} >
               <td >{item?.name}</td>
               <td >{item?.category?.name}</td>
               <td >
                <button
                 type="button"
                 className="count-button1"
                 onClick={() => {
                  navigator(`/stitching-option/${item?.id}`, {
                   state: item,
                  });
                 }}
                >
                 {item._count?.stitchingGroupOption}
                </button>
               </td>
               <td>{dateformate(item.updatedAt)}</td>
               {/* <td>{dateformate(item.createdAt)}</td> */}
               <td>
                <ActionButton
                 data={item}
                 handleEditClick={handleEditClick}
                 handleDelete={handleDelete}
                 module={"stitching"}
                />
               </td>
              </tr>
             );
            })
           ) : (
            <tr>
             <td colSpan="12" className="text-center">
              <h4> No data available</h4>
             </td>
            </tr>
           )}
          </tbody>
         </table>
        </div>
        {stitchingdata.length > 0 && (
         <div>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>

   <Suspense fallback={<p>Loading...</p>}>
    {deleteModalOpen && (
     <DeleteModel
      deleteModalOpen={deleteModalOpen}
      setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
      onConfirm={confirmDelete}
      itemName="Stitching Group And His Options And Measurements"
      isDeleting={isDeleting}
     />
    )}
   </Suspense>
  </>
 );
};

export default StitchingPage;
